module.exports = __webpack_public_path__ + "img/sign_ico_1.731b6b3d.svg";